import React from 'react'
import '../Styles/Salavdo.css'
import phoneVideo from '../Resources/Sala-ad-reel.mp4'
import desktopVideo from '../Resources/ad1.webm'

export const Salavdo = () => {
  return (
    <div className='salavdo-container'>
      <h1>Elegant & Evocative:</h1>
      <p>Step Into the Soul of Sala</p>
      <div className='salavdo-Vedio-frame'>
        <video className="video-container-element" autoPlay muted loop playsInline controls>
          <source src={desktopVideo} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className='salavdo-Vedio-frame-phone'>
        <video className="video-container-element-phone" autoPlay muted loop playsInline controls>
          <source src={phoneVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

    </div>
  )
}
